import React from "react";
import Form from "../../../HelperComponents/Form/Form";
import { FormField } from "../../../HelperComponents/Form/FormTypes";

type AddEditWorkHistoryProps = {
  isOpen: boolean;
  onDismiss: () => void;
  mode?: "save" | "update";
  workHistory?: any;
  itemId?: number | any;
};

const AddEditWorkHistory = (props: AddEditWorkHistoryProps) => {
  const fields: FormField[] = [
    {
      id: "Company",
      type: "Text",
      title: "Company",
      placeholder: "Company name",
      visible: true,
      value: props.mode === "update" ? props.workHistory?.Company : undefined,
      destinations: [{ destination: "workHistory", fieldName: "Company" }],
    },
    {
      id: "JobTitle",
      type: "Text",
      title: "Job Title",
      placeholder: "Role",
      visible: true,
      value: props.mode === "update" ? props.workHistory?.JobTitle : undefined,
      destinations: [{ destination: "workHistory", fieldName: "JobTitle" }],
    },
    {
      id: "Address",
      type: "Text",
      title: "Address",
      placeholder: "Address",
      visible: true,
      value:
        props.mode === "update" ? props.workHistory?.WorkAddress : undefined,
      destinations: [{ destination: "workHistory", fieldName: "WorkAddress" }],
    },
    {
      id: "Supervisor",
      type: "Text",
      title: "Supervisor",
      placeholder: "Supervisor name",
      visible: true,
      value:
        props.mode === "update" ? props.workHistory?.Supervisor : undefined,
      destinations: [{ destination: "workHistory", fieldName: "Supervisor" }],
    },
    {
      id: "PBSPhone",
      type: "Phone",
      title: "Phone",
      placeholder: "Supervisor phone",
      visible: true,
      value: props.mode === "update" ? props.workHistory?.PBSPhone : undefined,
      destinations: [{ destination: "workHistory", fieldName: "PBSPhone" }],
    },
    {
      id: "Employedmonth",
      type: "List",
      title: "Employed Month",
      placeholder: "Select month",
      visible: true,
      options: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      value:
        props.mode === "update" ? props.workHistory?.Employedmonth : undefined,
      destinations: [
        { destination: "workHistory", fieldName: "Employedmonth" },
      ],
    },
    {
      id: "EmployedYear",
      type: "Text",
      title: "Employed Year",
      placeholder: "e.g., 2020",
      visible: true,
      maxlength: 4,
      value:
        props.mode === "update" ? props.workHistory?.EmployedYear : undefined,
      destinations: [{ destination: "workHistory", fieldName: "EmployedYear" }],
    },
    {
      id: "UntilMonth",
      type: "List",
      title: "Until Month",
      placeholder: "Select month",
      visible: true,
      options: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      value:
        props.mode === "update" ? props.workHistory?.UntilMonth : undefined,
      destinations: [{ destination: "workHistory", fieldName: "UntilMonth" }],
    },
    {
      id: "UntilYear",
      type: "Text",
      title: "Until Year",
      placeholder: "e.g., 2023",
      visible: true,
      maxlength: 4,
      value: props.mode === "update" ? props.workHistory?.UntilYear : undefined,
      destinations: [{ destination: "workHistory", fieldName: "UntilYear" }],
    },
    {
      id: "Responsibilities",
      type: "Text",
      title: "Responsibilities",
      multiline: true,
      placeholder: "Key responsibilities",
      visible: true,
      value:
        props.mode === "update"
          ? props.workHistory?.Responsibilities
          : undefined,
      destinations: [
        { destination: "workHistory", fieldName: "Responsibilities" },
      ],
    },
    {
      id: "ReasonForLeaving",
      type: "Text",
      title: "Reason for Leaving",
      multiline: true,
      placeholder: "Explain briefly",
      visible: true,
      value:
        props.mode === "update"
          ? props.workHistory?.ReasonForLeaving
          : undefined,
      destinations: [
        { destination: "workHistory", fieldName: "ReasonForLeaving" },
      ],
    },
    {
      id: "ContactSupervisor",
      type: "Checkbox",
      title: "Contact Supervisor Allowed",
      visible: true,
      value:
        props.mode === "update"
          ? props.workHistory?.ContactSupervisor
          : undefined,
      destinations: [
        { destination: "workHistory", fieldName: "ContactSupervisor" },
      ],
    },
  ];

  return (
    <>
      {props.isOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          role="dialog"
          aria-modal="true"
        >
          <div
            style={{
              backgroundColor: "hsl(var(--background))",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              maxWidth: "1000px",
              width: "90%",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "16px 24px 24px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
                color: "hsl(var(--primary))",
              }}
            >
              <h2 style={{ margin: 0 }}>
                {props.mode === "update"
                  ? "Edit Work History"
                  : "Add Work History"}
              </h2>
              <button
                type="button"
                onClick={props.onDismiss}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 20,
                  lineHeight: 1,
                  color: "hsl(var(--foreground))",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <Form
              fields={fields}
              columns={3}
              mode={props.mode ?? "save"}
              itemId={
                props?.itemId ?? props.workHistory?.ID ?? props.workHistory?.Id
              }
              onCancel={props.onDismiss}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AddEditWorkHistory;
